import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { CoreTracking } from "../../../../models/CoreTracking";
import { InactivateEntraIdUserTracking } from "../../../../store/TrackingOperationAction";
import { EmptyRequestState } from "../../../../models/RequestState";
import ModalComponent from "../../../misc/ModalComponent";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import StatusCode from "../../../../util/StatusCode";
import CoreApiError from "../../../misc/CoreApiError";
import Loading from "../../../misc/Loading";
import { useTranslation } from 'react-i18next';
import { RootState } from "../../../../store/store";



interface InactivateEntraIdUserTrackingWizardProps {
    tracking: CoreTracking
    close: (success: boolean) => void
}

const InactivateEntraIdUserTrackingWizard: React.FC<InactivateEntraIdUserTrackingWizardProps> = (props) => {
    const dispatch = useDispatch();
    const [wizardStep, setWizardStep] = useState<'confirm' | 'done'>('confirm');
    const inactivateEntraIdUserTracking = useSelector<RootState, EmptyRequestState>(state => state.trackingOperation.inactivateEntraIdUserTracking);
    const { t } = useTranslation(['schoolAdministration', 'common']);
    
    const confirmInput: React.MouseEventHandler<HTMLButtonElement> = (_) => {
        InactivateEntraIdUserTracking(props.tracking.trackingId)(dispatch);
        setWizardStep('done');
    }

    const close = (success: boolean) => {
        setWizardStep('confirm');
        props.close(success);
    }

    switch (wizardStep) {
        case 'confirm': {
            return <ModalComponent
                isOpen={true}
                toggleModal={() => close(false)}
                header={t('trackingOperations.entraId.inactivate.modalTitle', {ns: 'schoolAdministration'})}
                update={confirmInput}
                confirm={t('action.confirm', {ns: 'common'})}
                cancel={t('action.cancel', {ns: 'common'})}>
                <p><FontAwesomeIcon title={t('status.warning', {ns: 'common'})} color="#fc1" icon={['fas', 'triangle-exclamation']} />{t('trackingOperations.entraId.inactivate.warningMessage', {ns: 'schoolAdministration', SourceSystemId: props.tracking.sourceSystemId  })}</p>
            </ModalComponent>
        }
        case 'done': {
            if (inactivateEntraIdUserTracking.code === StatusCode.COMPLETE) {
                return <ModalComponent
                    isOpen={true}
                    toggleModal={() => close(true)}
                    header={t('trackingOperations.entraId.inactivate.modalTitle', {ns: 'schoolAdministration'})}
                    cancel={t('action.close', {ns: 'common'})}>{t('trackingOperations.entraId.inactivate.confirm', {ns: 'schoolAdministration'})}</ModalComponent>
            } else if (inactivateEntraIdUserTracking.code === StatusCode.ERROR) {
                return <ModalComponent
                    isOpen={true}
                    toggleModal={() => close(false)}
                    header={t('trackingOperations.entraId.inactivate.modalTitle', {ns: 'schoolAdministration'})}
                    cancel={t('action.cancel', {ns: 'common'})}><CoreApiError  requestState={inactivateEntraIdUserTracking} /></ModalComponent>
            } else {
                return <ModalComponent
                    isOpen={true}
                    toggleModal={() => close(false)}
                    header={t('trackingOperations.entraId.inactivate.modalTitle', {ns: 'schoolAdministration'})}
                    cancel={t('action.cancel', {ns: 'common'})}>
                    <Loading />
                </ModalComponent>;
            }
        }
    }
}

export default InactivateEntraIdUserTrackingWizard;
